module.exports = __webpack_public_path__ + "src/assets/img/cd02-mask.08cc5114.png";